var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasSubMenu
    ? _c(
        "CompassMenu",
        {
          ref: "mainMenu",
          attrs: {
            placement: "bottom",
            trigger: "hover",
            customClass: "nav-item__add-menu"
          },
          scopedSlots: _vm._u(
            [
              {
                key: "dropdown",
                fn: function() {
                  return [
                    _c("CompassMenuSubtitle", {
                      attrs: { label: _vm.translations.menuSubTitle }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.itemSubMenu, function(subItem) {
                      return [
                        subItem.nestedItems && subItem.nestedItems.length > 0
                          ? _c(
                              "CompassMenuGroup",
                              {
                                key: "group-" + subItem.txt,
                                attrs: {
                                  label: subItem.txt,
                                  icon: subItem.icon,
                                  placement: "right-start",
                                  customClass: "nav-item__add-menu-group"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "dropdown",
                                      fn: function() {
                                        return _vm._l(
                                          subItem.nestedItems,
                                          function(subSubItem) {
                                            return _c("CompassMenuItem", {
                                              key: "item-" + subSubItem.txt,
                                              attrs: { label: subSubItem.txt },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleMenuAction(
                                                    subSubItem
                                                  )
                                                }
                                              }
                                            })
                                          }
                                        )
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                subItem.icon
                                  ? _c("NavItemAddIcon", {
                                      attrs: { icon: subItem.icon }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-regular"
                                  },
                                  [_vm._v(_vm._s(subItem.txt))]
                                )
                              ],
                              1
                            )
                          : _c(
                              "CompassMenuItem",
                              {
                                key: "direct-" + subItem.txt,
                                attrs: { label: subItem.txt },
                                on: {
                                  click: function($event) {
                                    return _vm.handleMenuAction(subItem)
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prefixIcon",
                                      fn: function() {
                                        return [
                                          subItem.icon
                                            ? _c("NavItemAddIcon", {
                                                attrs: { icon: subItem.icon }
                                              })
                                            : _vm._e()
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-regular"
                                  },
                                  [_vm._v(_vm._s(subItem.txt))]
                                )
                              ]
                            )
                      ]
                    })
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            2482133494
          )
        },
        [
          _c(
            "div",
            { staticClass: "nav-item__actions--item-link" },
            [
              _vm.item.isNew
                ? _c("CompassFlag", {
                    staticClass: "nav-item__actions--item-link-flag",
                    attrs: {
                      label: _vm.$t.__("common.labels.tag.new"),
                      size: "small"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CompassIcon", {
                staticClass: "nav-item__actions--item-icon",
                attrs: { icon: _vm.item.icon }
              })
            ],
            1
          )
        ]
      )
    : _c(
        "a",
        {
          staticClass: "nav-item__actions--item-link",
          attrs: { href: _vm.item.url }
        },
        [
          _vm.item.isNew
            ? _c("CompassFlag", {
                staticClass: "nav-item__actions--item-link-flag",
                attrs: {
                  label: _vm.$t.__("common.labels.tag.new"),
                  size: "small"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("CompassIcon", {
            class: [
              "nav-item__actions--item-icon",
              {
                "nav-item__actions--item-icon--animated": _vm.isSponsorshipItem
              }
            ],
            attrs: { icon: _vm.item.icon }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }